import { SelectMenu, type SelectOption } from "@/app/components/SelectMenu"
import type { ClientTheme } from "@/app/lib/themes"

interface SelectFilterProps {
  value: string
  onChange: (v: string) => void
  placeholder: string
  options: SelectOption[]
  width?: string
  theme: ClientTheme
}

/**
 * Single-select filter control. A thin wrapper over the shared SelectMenu where
 * `placeholder` is the clearable "All …" / unset row (value ""), so every filter
 * and form dropdown shares one themed popover.
 */
export function SelectFilter({
  value,
  onChange,
  placeholder,
  options,
  width = "180px",
  theme,
}: SelectFilterProps) {
  return (
    <SelectMenu
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      width={width}
      theme={theme}
    />
  )
}
